<template>
    <div>
        <rkm-row>
            <rkm-col cols="4">

                <rkm-form-input
                    label="CEP"
                    :validations="validations.cep"
                    v-mask="mask.cep"
                    v-model="form.cep"
                    validation-mode="lazy-change"
                    :disabled="!isPermissaoEndereco"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-button
                            @click="$refs.ModalLogradouro.open()"
                            color="primary"
                            title="Cadastrar logradouro"
                            :disabled="!isPermissaoEndereco"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="8">
                <rkm-button
                    :label="false"
                    @click.stop="$refs.ModalBuscaLogradouro.open()"
                    :disabled="!isPermissaoEndereco"
                >
                    Não sei meu CEP
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input-autocomplete
                    :searchFields="localForm.autocompleteFields.logradouro"
                    :repository="repositories.logradouro"
                    :requestQueryStringParams="{ cep: unMaskCep(form.cep) }"
                    v-model="model.domicilio.endereco.logradouro"
                    :textField="l => `${l.tipo.descricao} ${l.nome} - ${l.bairro.nome}`"
                    :validations="validations.logradouro"
                    :disabled="!form.cep || !isPermissaoEndereco"
                    @change="handleResponsavel()"
                    label="Logradouro"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :disabled="!form.cep || form.semNumero || !isPermissaoEndereco"
                    :validations="validations.numero"
                    label="Número"
                    v-model="model.domicilio.endereco.numero"
                    @change="handleResponsavel()"
                    number
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                inline
                                v-model="form.semNumero"
                                :disabled="!form.cep || !isPermissaoEndereco"
                                @change="handleResponsavel()"
                            >
                                Sem número
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    :validations="validations.complemento"
                    label="Complemento"
                    v-model="model.domicilio.endereco.complemento"
                    :disabled="!form.cep || !isPermissaoEndereco"
                    @change="handleResponsavel()"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    :validations="validations.referencia"
                    label="Ponto de referência"
                    v-model="model.domicilio.endereco.referencia"
                    :disabled="!form.cep || !isPermissaoEndereco"
                    uppercase
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    disabled
                    label="Bairro"
                    v-model="form.bairroNome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :searchFields="localForm.autocompleteFields.loteamento"
                    :repository="repositories.loteamento"
                    v-model="model.domicilio.endereco.loteamento"
                    :validations="validations.loteamento"
                    label="Loteamento"
                    :disabled="!form.cep || !isPermissaoEndereco"
                    uppercase
                >
                    <rkm-input-group-append slot="append">
                        <rkm-button
                            @click="$refs.ModalLoteamento.open()"
                            color="primary"
                            title="Cadastrar loteamento"
                            :disabled="!form.cep || !isPermissaoEndereco"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </rkm-input-group-append>
                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    disabled
                    label="Município de residência"
                    v-model="form.municipioNome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    disabled
                    label="UF"
                    v-model="form.estadoUf"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    disabled
                    label="Código IBGE"
                    v-model="form.ibge"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    disabled
                    label="País"
                    v-model="form.paisNome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.zonas"
                    label="Zona"
                    text-field="descricao"
                    v-model="model.domicilio.endereco.zonaId"
                    value-field="id"
                    :validations="validations.zona"
                    :disabled="!form.cep || !isPermissaoEndereco"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.latitude"
                    label="Latitude"
                    v-model="model.domicilio.endereco.latitude"
                    :disabled="!form.cep || !isPermissaoEndereco"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.longitude"
                    label="Longitude"
                    v-model="model.domicilio.endereco.longitude"
                    :disabled="!form.cep || !isPermissaoEndereco"
                    uppercase
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-date-picker
                    label="Reside no domicílio desde"
                    v-model="model.dataEntradaDomicilio"
                    :min-date="getDataNascimentoString()"
                    :max-date="dataAtual"
                    :validations="validations.dataEntradaDomicilio"
                    :disabled="!form.cep || !isPermissaoEndereco"
                />
            </rkm-col>

            <rkm-col cols="8">
                <rkm-form-input
                    disabled
                    label="Tempo de habitação"
                    v-model="form.tempoHabitacao"
                />
            </rkm-col>
        </rkm-row>

        <ModalLogradouro
            ref="ModalLogradouro"
            @save="loadLogradouro"
        />

        <ModalBuscaLogradouro
            :disable-filters="disableFilters"
            @select="loadLogradouro"
            ref="ModalBuscaLogradouro"
        />

        <ModalLoteamento
            ref="ModalLoteamento"
            @save="model.domicilio.endereco.loteamento = $event"
        />
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Components.
import ModalLogradouro from '@/components/cadastro/logradouro/Modal'
import ModalBuscaLogradouro from '@/components/cadastro/logradouro/busca/Modal'
import ModalLoteamento from '@/components/cadastro/loteamento/Modal'

// Unums
import saidaCidadao from '@/enums/atencao-basica/saidaCidadao'

// Mixins.
import { repository, error, mask, unmask, formats, importacaoCns, stringCase } from '@/mixins'

export default {
    mixins: [ repository, error, mask, unmask, formats, importacaoCns, stringCase ],
    components: {
        ModalLogradouro,
        ModalBuscaLogradouro,
        ModalLoteamento
    },
    props: {
        origem: { type: String, default: null },
        dataAtual: { type: String, required: true },
        disableFilters: { type: Boolean },
        isPermissaoEndereco: { type: Boolean },
        isResponsavel: { type: Boolean , default: false},
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        termosInvalidos: { type: Array, required: true },
        saidaCidadaoId:{ type:Number, default:null}
    },
    data: () => ({

        repositories: {
            logradouro: null,
            loteamento: null,
            geral: null,
        },
        enums: {
            saidaCidadao
        },
        localForm: {
            autocompleteFields: {
                logradouro: [
                    { key: 'tipo.descricao', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                loteamento: [
                    { key: 'nome', searchable: true },
                ],
            },
        },
        skipFirstCepSync: true,
        resetResidentes: false,
    }),
    computed: {
        validations() {

            return {
                cep: {
                    required: !(this.saidaCidadaoId == this.enums.saidaCidadao.MUDANCA_DE_TERRITORIO || this.saidaCidadaoId == this.enums.saidaCidadao.OBITO),
                    min_max_without_mask: 8,
                    has_cep: true,
                },
                logradouro: {
                    required: !!this.form.cep
                },
                numero: {
                    required: !!this.form.cep && !this.form.semNumero,
                    max: 6
                },
                complemento: {
                    min: 3,
                    max: 180,
                    regex: this.importacaoCns.regexValidacao,
                    termo_invalido: this.termosInvalidos,
                },
                referencia: {
                    max: 150,
                    regex: this.importacaoCns.regexValidacao,
                    termo_invalido: this.termosInvalidos,
                },
                loteamento: {},
                zona: {
                    required: !!this.form.cep
                },
                dataEntradaDomicilio: {},
                latitude: {
                    min: 10,
                    max: 10
                },
                longitude: {
                    min: 10,
                    max: 10
                }
            }
        }
    },
    watch: {
        'form.cep': function (cep) {

            this.model.domicilio.endereco.logradouro = null

            if (this.skipFirstCepSync) {

                this.skipFirstCepSync = false
            }
            else if (cep) {

                this.$emit('limpar-informacoes-sociais');
            }

            if (!cep) {

                this.model.domicilio.endereco.numero = null
                this.form.semNumero = false

                this.model.domicilio.endereco.complemento = ''
                this.model.domicilio.endereco.referencia = ''
                this.model.domicilio.endereco.loteamento = null
                this.model.domicilio.endereco.zonaId = null
                this.model.domicilio.endereco.latitude = null
                this.model.domicilio.endereco.longitude = null
                this.model.dataEntradaDomicilio = null
            }
        },
        'form.semNumero': function (semNumero) {

            if (semNumero) {

                this.model.domicilio.endereco.numero = null
            }
        },
        'model.domicilio.endereco.logradouro': function (logradouro) {

            if (logradouro) {

                this.form.bairroNome = logradouro.bairro.nome
                this.form.municipioNome = logradouro.municipio.nome
                this.form.estadoUf = logradouro.municipio.estado.uf
                this.form.ibge = logradouro.municipio.ibge
                this.form.paisNome = logradouro.municipio.estado.pais.nome
            }
            else {

                this.form.bairroNome = ''
                this.form.municipioNome = ''
                this.form.estadoUf = ''
                this.form.ibge = ''
                this.form.paisNome = ''
            }
        },
        'model.dataEntradaDomicilio': function (date) {

            if (date instanceof Date) {

                this.setLoading()

                this.repositories.geral.calcularDiferencaTempo({
                    ano: date.getFullYear(),
                    mes: (date.getMonth() + 1).toString().padStart(2, '0'),
                    dia: date.getDay().toString().padStart(2, '0'),
                })
                    .then(({ data }) => {

                        this.form.tempoHabitacao = `${data.anos} Ano(s), ${data.meses} Mes(es), ${data.dias} Dia(s)`
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
            else {

                this.form.tempoHabitacao = null
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadLogradouro(logradouro) {

            this.form.cep = this.formatCep(logradouro.cep)

            this.$nextTick(() => this.model.domicilio.endereco.logradouro = logradouro)
        },
        getDataNascimentoString() {

            return this.model.dataNascimento
                ? moment(this.model.dataNascimento).format('DD/MM/YYYY')
                : null
        },
        isEndereco() {

            return this.model.domicilio.endereco.logradouro
                && this.model.domicilio.endereco.logradouro.id
                && (this.model.domicilio.endereco.numero || this.form.semNumero)
        },
        handleResponsavel() {

            if (this.isResponsavel) {

                this.showConfirmation(
                    `Você está alterando o endereço do Responsável Familiar. Deseja aplicar essa alteração a toda a
                    família? A mudança será realizada somente após clicar em Salvar.`,
                    async () => {
                        this.$emit('alterResponsavel', true)
                        this.getDomicilio()
                    },
                    async () => this.getDomicilio(),
                )
            } else {
                this.getDomicilio()
            }
        },
        limparEnderecoImovelInativo() {

            this.form.cep = ''

            this.$emit('setFieldsDomicilio', { residentes: [], informacaoResidencial: null })

            this.showAlert(`O endereço informado pertence a um imóvel inativo, que não permite o vínculo
                de novos moradores. O endereço foi limpo. Reative o cadastro domiciliar deste imóvel ou
                informe outro endereço.`, 'Atenção')
        },
        getDomicilio() {

            if (this.isEndereco() && this.origem === 'cadastroPaciente') {

                this.setLoading()

                const request = {
                    logradouroId: this.model.domicilio.endereco.logradouro.id,
                    numero: this.model.domicilio.endereco.numero,
                    complemento: this.model.domicilio.endereco.complemento,
                }

            this.repositories.paciente.getDomicilio(this.camelObjectKeysToSnakeRecursive(request))
                .then((response) => {

                    const informacaoResidencial = response.data.informacaoResidencial

                    if (informacaoResidencial && informacaoResidencial.ativo === false) {

                        this.limparEnderecoImovelInativo()

                        return
                    }

                    this.$emit('setFieldsDomicilio', response.data);

                    if (informacaoResidencial) {

                        this.showAlert(`Com as informações de endereço foi identificado um domicílio já existente.
                            Assim, os campos relacionados ao domicílio na aba 'Informações Residenciais' foram atualizados
                            com os dados deste domicílio, e a listagem de residentes também foi atualizada.`, 'Atenção');
                    } else {

                        this.showAlert(`Com as informações fornecidas, identificamos que se trata de um novo domicílio.
                            Os campos na aba 'Informações Residenciais' foram preparados para o cadastro.`, 'Atenção');
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
    },
    created() {

        this.repositories.logradouro = this.getConectaSusRepository('cadastro.localizacao.logradouro')
        this.repositories.loteamento = this.getConectaSusRepository('cadastro.localizacao.loteamento')
        this.repositories.geral = this.getConectaSusRepository('geral')
        this.repositories.paciente = this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')
    }
}
</script>